var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfterHoursReferralRules({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.019,
    cy: 38.881,
    r: 2.684,
    className: "stroke fill"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M29.019 18.252v17.945m27.425 4.461c-.918 14.341-12.855 25.704-27.425 25.704-15.167 0-27.481-12.314-27.481-27.481S13.852 11.4 29.019 11.4a27.35 27.35 0 0 1 16.639 5.614"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M73.462 32.882c-2.801 4.658-7.904 7.776-13.73 7.776-8.836 0-16.011-7.174-16.011-16.01s7.175-16.01 16.011-16.01h.018a15.34 15.34 0 0 0-2.812 8.873c0 8.505 6.905 15.411 15.411 15.411q.563 0 1.113-.04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M29.019 61.622v-2.38M8.265 38.881h-2.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterHoursReferralRules);
export default __webpack_public_path__ + "static/media/after-hours-referral-rules.601f7efc8db8787d041155313ef639b8.svg";
export { ForwardRef as ReactComponent };